// @flow

import React from 'react';
import styled, { css } from 'styled-components';
import { ifProp } from 'styled-tools';
import { toNumber } from 'lodash';

type Props = {
  bottom?: number,
};

const Wrapper = styled.div`
  ${ifProp(
    'bottom',
    css`
      margin-bottom: ${({ bottom }) => toNumber(bottom) * 10}px;
    `,
  )};
`;

const Margin = (props: Props) => <Wrapper {...props} />;

export default Margin;
